enum PaymentMethodStatus {
  Default = 'Default',
  Active = 'Active',
  Expired = 'Expired',
}
export default PaymentMethodStatus;
